import { Card, CardContent } from './card';
import { cn } from '../lib/utils';

interface StatCardProps {
  title: string;
  value: string | number;
  description?: string;
  className?: string;
}

export function StatCard({ title, value, description, className }: StatCardProps) {
  return (
    <Card className={cn('bg-white/70 backdrop-blur-xl dark:bg-zinc-900/70', className)}>
      <CardContent>
        <p className="text-sm font-medium text-zinc-500">{title}</p>
        <p className="mt-2 text-3xl font-bold tracking-tight text-zinc-900 dark:text-zinc-100">{value}</p>
        {description && <p className="mt-1 text-sm text-zinc-500">{description}</p>}
      </CardContent>
    </Card>
  );
}
